const actions = {
  TRANSACTION_REPORTS: "TRANSACTION_REPORTS",
  TRANSACTION_REPORTS_SUCCESS: "TRANSACTION_REPORTS_SUCCESS",
  TRANSACTION_REPORTS_FAILED: "TRANSACTION_REPORTS_FAILED",

  ACTIVATION_BATCH_REPORTS: "ACTIVATION_BATCH_REPORTS",
  ACTIVATION_BATCH_REPORTS_SUCCESS: "ACTIVATION_BATCH_REPORTS_SUCCESS",
  ACTIVATION_BATCH_REPORTS_FAILED: "ACTIVATION_BATCH_REPORTS_FAILED",

  RECHARGE_BATCH_REPORTS: "RECHARGE_BATCH_REPORTS",
  RECHARGE_BATCH_REPORTS_SUCCESS: "RECHARGE_BATCH_REPORTS_SUCCESS",
  RECHARGE_BATCH_REPORTS_FAILED: "RECHARGE_BATCH_REPORTS_FAILED",

  WIFI_BATCH_REPORTS: "WIFI_BATCH_REPORTS",
  WIFI_BATCH_REPORTS_SUCCESS: "WIFI_BATCH_REPORTS_SUCCESS",
  WIFI_BATCH_REPORTS_FAILED: "WIFI_BATCH_REPORTS_FAILED",

  RESET_MESSAGE: "RESET_MESSAGE",

  getTransactionReports: (data) => ({
    type: actions.TRANSACTION_REPORTS,
    payload: { data },
  }),
  transactionReportsSuccess: (data) => ({
    type: actions.TRANSACTION_REPORTS_SUCCESS,
    payload: {data}
  }),
  transactionReportsFailed: (error) => ({
    type: actions.TRANSACTION_REPORTS_FAILED,
    payload: { error },
  }),

  resetMessage: () => ({
    type: actions.RESET_MESSAGE,
  }),

  getactivationBatchReports: (data) => ({
    type: actions.ACTIVATION_BATCH_REPORTS,
    payload: { data },
  }),
  activationBatchReportsSuccess: (data) => ({
    type: actions.ACTIVATION_BATCH_REPORTS_SUCCESS,
    payload: {data}
  }),
  activationBatchReportsFailed: (error) => ({
    type: actions.ACTIVATION_BATCH_REPORTS_FAILED,
    payload: { error },
  }),

  getrechargeBatchReports: (data) => ({
    type: actions.RECHARGE_BATCH_REPORTS,
    payload: { data },
  }),
  rechargeBatchReportsSuccess: (data) => ({
    type: actions.RECHARGE_BATCH_REPORTS_SUCCESS,
    payload: {data}
  }),
  rechargeBatchReportsFailed: (error) => ({
    type: actions.RECHARGE_BATCH_REPORTS_FAILED,
    payload: { error },
  }),

  getWiFiBatchReports: (data) => ({
    type: actions.WIFI_BATCH_REPORTS,
    payload: { data },
  }),
  getWiFiBatchReportsSuccess: (data) => ({
    type: actions.WIFI_BATCH_REPORTS_SUCCESS,
    payload: {data}
  }),
  getWiFiBatchReportsFailed: (error) => ({
    type: actions.WIFI_BATCH_REPORTS_FAILED,
    payload: { error },
  }),
}

export default actions;